import React from 'react'
import { Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'

const IndustrialEnvironments = () => {

  return (
    <>
        <Card className='no-border rounded-0 container text-center'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'>Digital Twins in Industrial Environments</Card.Title>
                <Card.Text className='industrial-environment-text'>
                Digital twins are one of the most effective and ROI - driven applications of immersive technology, and many industrial enterprises use them as an initiation into AR/VR programs. Digital twins can be created for individual parts, complex workflows, entire sys tems, and even products still in R&D that don’t exist in the physical world yet.
                <br />
                <br />
                Digital twins are helping enterprises:
                </Card.Text>
            </Card.Body>
            <Row>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/dt_001.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text>Monitor and optimize automated systems</Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/dt_002.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text>Plan for disaster management</Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/dt_003.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text>Test products in development</Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/dt_004.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text>Manage supply chain challenges</Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:2}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/dt_005.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text>Run production floor scenarios before implementing changes</Card.Text>
                        </Col>
                    </Row>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:4, offset:0}} className="py-2 py-md-4">
                    <Row>
                        <Col xs={{span:2, offset:0}} className="text-end">
                            <Card.Img className='photography-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/dt_006.png"} alt="" />
                        </Col>
                        <Col xs={{span:8, offset:0}} className="text-start">
                            <Card.Text>Plan for preventive maintenance</Card.Text>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:3}} className="py-md-5 my-md-3 py-4">
                <Card.Img className='' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/industrial-banner.jpg"} />
                </Col>
            </Row>

        </Card>
        <Card className='no-border rounded-0 container my-md-0 py-md-0 py-5 my-4'>
            <Row>
                <Col>
                <Carousel className='industrial-carousel' interval={null}>
                <CarouselItem>
                        <Row>

                        <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>

                        <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 left-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card '>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Real Life<br /> Reference Photo</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='main-slider-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>Virtual Image Rendered <br /> From 3D Models</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={{span:1, offset:0}} className="d-none d-md-block">
                                <Card className='no-border rounded-0 right-partial-display-section'>
                                    <Card.Img className='partial-display-image' src={process.env.PUBLIC_URL + "assets/digital-twin/industrial/ind_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'></Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                </Carousel>
                </Col>
            </Row>

        </Card>
      
    </>
  )
}

export default IndustrialEnvironments
